module.exports = __webpack_public_path__ + "media/images/go_to_link-d5cf9687.svg";